/* Native Shopify variants own price and stock. Measurements use the supplied inch choices. */
(() => {
  if (customElements.get('alaswad-sizing')) return;
  class AlaswadSizing extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.form = this.closest('form');
      this.measurements = this.querySelector('[data-measurements]');
      this.property = this.querySelector('[data-sizing-property]');
      if (!this.form || !this.measurements || !this.property) return;
      this.customIds = JSON.parse(this.querySelector('[data-custom-variants]').textContent).map(String);
      this.variantSizes = new Map(JSON.parse(this.querySelector('[data-variant-sizes]')?.textContent || '[]').map(([id,size]) => [String(id),size]));
      this.groups = Array.from(this.querySelectorAll('[data-measurement]'));
      this.base = this.querySelector('[data-base-size]');
      this.arabic = document.documentElement.lang.startsWith('ar');
      this.dirty = false;
      this.prefilled = false;
      try { this.presets = JSON.parse(this.dataset.presets || 'null'); } catch { this.presets = null; }
      if (!this.presets || this.presets.unit !== 'Inches' || !this.presets.sizes || typeof this.presets.sizes !== 'object' || Array.isArray(this.presets.sizes)) this.presets = null;
      if (this.presets) {
        this.rows = Object.keys(this.presets.sizes).filter(key => {
          const row = this.presets.sizes[key];
          return row && typeof row === 'object' && this.groups.some(group => {
            const name = group.querySelector('[data-measurement-value]').name.slice(11,-1);
            return this.number(row[name]) > 0;
          });
        });
        if (!this.rows.length) this.presets = null;
        else {
          this.base.replaceChildren();
          this.rows.forEach(key => this.base.add(new Option(key,key)));
          this.base.disabled = false;
          this.querySelector('[data-base-wrap]').hidden = false;
        }
      }
      this.onChange = event => {
        if (event.target === this.base && this.presets) {
          if (this.dirty && !window.confirm(this.arabic ? 'استبدال المقاسات المعدّلة بمقاسات هذا المقاس؟' : 'Replace your edited measurements with this size’s defaults?')) this.base.value = this.loadedBase;
          else this.fill(this.base.value);
        } else if (event.target.closest?.('[data-measurement]')) this.dirty = true;
        this.sync();
      };
      this.onInput = event => {
        if (event.target.matches('[data-manual]')) { this.dirty = true; this.syncFields(); }
      };
      this.onSubmit = event => {
        this.sync();
        if (this.dataset.customActive !== 'true') return;
        const invalid = Array.from(this.measurements.querySelectorAll('input, select, textarea')).find(field => !field.checkValidity());
        if (invalid) {
          event.preventDefault(); event.stopImmediatePropagation();
          invalid.reportValidity(); invalid.focus();
        }
      };
      this.onReset = () => setTimeout(() => { this.prefilled = false; this.dirty = false; this.sync(); }, 0);
      this.form.addEventListener('change', this.onChange);
      this.measurements.addEventListener('input', this.onInput);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.form.addEventListener('reset', this.onReset);
      document.addEventListener('variant:changed', this.onChange);
      this.connected = true;
      this.sync();
    }
    number(value) {
      if (typeof value === 'string' && /^\d+ 1\/2$/.test(value)) return Number(value.split(' ')[0]) + 0.5;
      const n = Number(value);
      return Number.isFinite(n) ? n : NaN;
    }
    fill(size) {
      const row = this.presets.sizes[size];
      this.groups.forEach(group => {
        const output = group.querySelector('[data-measurement-value]');
        const manual = group.querySelector('[data-manual]');
        const select = group.querySelector('[data-choice]');
        const raw = row[output.name.slice(11,-1)];
        const n = this.number(raw);
        if (!(n > 0)) { if (select) select.value = ''; if (manual) manual.value = ''; return; }
        const option = select && Array.from(select.options).find(o => o.value && this.number(o.value) === n);
        if (select) select.value = option ? option.value : '';
        if (manual) manual.value = String(n);
      });
      this.base.value = size; this.loadedBase = size; this.prefilled = true; this.dirty = false;
    }
    syncFields() {
      const custom = this.dataset.customActive === 'true';
      this.groups.forEach(group => {
        const select = group.querySelector('[data-choice]');
        const manual = group.querySelector('[data-manual]');
        const own = !select;
        if (manual) {
          manual.hidden = !own;
          manual.disabled = !custom || !own;
          manual.required = custom && own;
        }
        if (select) select.required = custom;
        group.querySelector('[data-measurement-value]').value = own ? manual.value : select.value;
      });
    }
    sync() {
      const id = this.form.querySelector('input[name="id"]')?.value;
      const custom = this.customIds.includes(String(id));
      if (!custom && id) this.lastStandard = this.variantSizes.get(String(id));
      if (custom && this.presets && !this.prefilled) {
        const matching = this.rows.find(key => key.toLowerCase() === String(this.lastStandard || '').toLowerCase());
        this.fill(matching || this.rows[0]);
      }
      const changed = this.dataset.customActive !== String(custom);
      this.dataset.customActive = String(custom);
      this.property.value = custom ? 'Customize' : 'Standard';
      this.measurements.hidden = !custom;
      this.measurements.disabled = !custom;
      this.measurements.querySelectorAll('[data-required]').forEach(field => field.required = custom);
      this.syncFields();
      if (changed) this.dispatchEvent(new CustomEvent('alaswad:sizing-change', { bubbles:true }));
    }
    disconnectedCallback() {
      if (!this.connected) return;
      this.form.removeEventListener('change', this.onChange);
      this.measurements.removeEventListener('input', this.onInput);
      this.form.removeEventListener('submit', this.onSubmit, true);
      this.form.removeEventListener('reset', this.onReset);
      document.removeEventListener('variant:changed', this.onChange);
      this.connected = false;
    }
  }
  customElements.define('alaswad-sizing', AlaswadSizing);
})();

/* Al Aswad delivery estimate: Dubai date; order date is day zero; skip Sundays. */
(() => {
  if (window.__alaswadDeliveryInstalled) return;
  window.__alaswadDeliveryInstalled = true;
  const selector = '.m-product-shipping-delivery__text';
  const labels = new Set();
  let midnightTimer;
  let cachedKey = '';
  let cachedDates;
  const dubaiFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Dubai', year: 'numeric', month: '2-digit', day: '2-digit'
  });
  let queued = false;

  function dubaiToday() {
    const parts = dubaiFormatter.formatToParts(new Date());
    const part = (type) => Number(parts.find((item) => item.type === type).value);
    return new Date(Date.UTC(part('year'), part('month') - 1, part('day')));
  }

  function addDeliveryDays(start, days) {
    const result = new Date(start.getTime());
    let counted = 0;
    while (counted < days) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (result.getUTCDay() !== 0) counted++;
    }
    return result;
  }

  function update() {
    queued = false;
    for (const label of labels) if (!label.isConnected) labels.delete(label);
    if (!labels.size) return;
    const today = dubaiToday();
    const arabic = document.documentElement.lang.toLowerCase().startsWith('ar');
    const key = today.getTime() + ':' + arabic;
    if (cachedKey !== key) {
      const formatter = new Intl.DateTimeFormat(arabic ? 'ar-AE' : 'en-GB', {
        calendar: 'gregory', year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC'
      });
      cachedDates = {
        standard: formatter.format(addDeliveryDays(today, 2)),
        custom: formatter.format(addDeliveryDays(today, 7)) + ' – ' + formatter.format(addDeliveryDays(today, 10))
      };
      cachedKey = key;
    }
    labels.forEach((label) => {
      const info = label.closest('.m-main-product--info');
      if (!info) return;
      const selected = info.querySelector('alaswad-sizing input[data-sizing-property]');
      const custom = selected && selected.value === 'Customize';
      const text = custom ? cachedDates.custom : cachedDates.standard;
      if (label.textContent !== text) label.textContent = text;
      if (label.getAttribute('aria-live') !== 'polite') label.setAttribute('aria-live', 'polite');
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }

  function discover(root) {
    if (root.nodeType !== 1 && root !== document) return false;
    let found = false;
    if (root.matches?.(selector)) { labels.add(root); found = true; }
    root.querySelectorAll(selector).forEach(label => { labels.add(label); found = true; });
    return found;
  }

  function midnightRefresh() {
    clearTimeout(midnightTimer);
    if (!labels.size || document.hidden) return;
    // Dubai is UTC+4. Refresh once at midnight instead of polling every minute.
    const day = 86400000, now = Date.now();
    const wait = day - ((now + 14400000) % day) + 100;
    midnightTimer = setTimeout(() => { schedule(); midnightRefresh(); }, wait);
  }

  function start() {
    discover(document);
    update();
    midnightRefresh();
    document.addEventListener('alaswad:sizing-change', schedule);
    document.addEventListener('variant:changed', schedule);
    document.addEventListener('reset', schedule);
    document.addEventListener('shopify:section:load', event => {
      discover(event.target); schedule(); midnightRefresh();
    });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) schedule();
      midnightRefresh();
    });
    window.addEventListener('pageshow', () => { schedule(); midnightRefresh(); });
    // Track newly inserted quick views/sections; ordinary text and field edits do not trigger an update.
    new MutationObserver(records => {
      let found = false;
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === 1 && discover(node)) found = true;
        }
      }
      if (found) { schedule(); midnightRefresh(); }
      for (const label of labels) if (!label.isConnected) labels.delete(label);
      if (!labels.size) clearTimeout(midnightTimer);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
